import createIcon from '../../createIcon';

/**
 * @component @name Crop169
 * @description Google Material SVG icon component, renders SVG Element with children.
 *
 * @preview ![img](data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTkgN0g1QzMuOSA3IDMgNy45IDMgOVYxNUMzIDE2LjEgMy45IDE3IDUgMTdIMTlDMjAuMSAxNyAyMSAxNi4xIDIxIDE1VjlDMjEgNy45IDIwLjEgNyAxOSA3Wk0xOSAxNUg1VjlIMTlWMTVaIiBmaWxsPSJibGFjayIvPgo8L3N2Zz4K)
 *
 * @param {Object} props - Google Material icons props and any valid SVG attribute
 * @returns {JSX.Element} JSX Element
 *
 */
const Crop169 = createIcon('Crop169', [
  [
    'path',
    {
      d: 'M19 7H5C3.9 7 3 7.9 3 9V15C3 16.1 3.9 17 5 17H19C20.1 17 21 16.1 21 15V9C21 7.9 20.1 7 19 7ZM19 15H5V9H19V15Z',
      key: '1vdcan',
    },
  ],
]);

export default Crop169;
